import { Label, Main } from './Isometry.Controls.Arrows.style'
import { useState }    from 'react'
import { animate }     from 'framer-motion'
import { Arrow }       from './Isometry.Controls.Arrows.assets'
import { useBreak }    from 'hooks/useBreak'
import { motion }      from 'framer-motion'
import { active_project, rotate_by_slider } from 'state/store.global'
import { getFocus, setFocus, useGet, useSet } from 'state/jotai'
import { _project } from 'state/store.projects'
import { getIsoData } from 'state/jotai.isometryDataHooks'
import { _bootstrap } from 'state/store.bootstrap'
import { _isometry } from 'state/store.isometry'
import styled from 'styled-components'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { useLocation } from 'react-router-dom'
import {  BREAK_ } from 'constants'
import { darken } from 'polished'

export const Arrows = ({frame,setFrame,config,index,setIndex}) => {
  const type = getFocus(_bootstrap, "type");
  const here = useLocation().pathname;
  const isIsometry = here.includes("isometry")
  const [state, setState] = useState(0)
  const [showTooltip, setShowTooltip] = useState(false)
  const isMobile = useBreak('md_dn')
  const SNP = config.IMAGE_SNAPFRAMES 

  const MAX = SNP?.length - 1
  const MIN = 0
  const setRotate_Done = useSet(rotate_by_slider)
  const { pin, pid } = useGet(active_project)
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []
  const percent = getIsoData('percent')

  const pids   = useGet(_bootstrap).projectids
  const allConfig     = getFocus(_isometry, 'config')
  
  const setFrameFocus = setFocus(_isometry, 'activeframe')
  const getFrame = getFocus(_isometry, 'activeframe')
  const click = (DIR) => {
    setRotate_Done(false);

    // prevent multiple clicks during animation
    if (state === 1) return;
    setState(1);

    // ✅ Validate SNP
    if (!Array.isArray(SNP) || SNP.length === 0) {
      console.warn("⚠️ No valid SNP array found", { SNP });
      setState(0);
      return;
    }

    const MAX = SNP.length - 1;
    const MIN = 0;

    // ✅ Compute from/to safely
    const from =
      index === MAX && DIR > 0
        ? SNP[MIN]
        : index === MIN && DIR < 0
        ? SNP[MAX]
        : SNP[index];

    const to =
      index === MAX && DIR > 0
        ? SNP[1]
        : index === MIN && DIR < 0
        ? SNP[MAX - 1]
        : SNP[index + DIR];

    const toIndex =
      index === MAX && DIR > 0
        ? 1
        : index === MIN && DIR < 0
        ? MAX - 1
        : index + DIR;
  
     // ✅ Guard invalid frames
    if (from === undefined || to === undefined || isNaN(from) || isNaN(to)) {
      console.warn("⚠️ Invalid frame values", { from, to, index, SNP });
      setState(0);
      return;
    }

    setIndex(toIndex);
  
    // Define roundedValue before usage
    let roundedValue = from;
  
    // Animation logic
  // ✅ Animate safely
  let lastValue = from;

   if (pin === 0) {
    animate(from, to, {
      duration: 0.5,
      ease: "easeInOut",
      onUpdate: (v) => {
        const roundedValue = Math.round(v);
        if (roundedValue !== lastValue) {
          lastValue = roundedValue;
        
          setFrameFocus((prevFrame) => {
            if (prevFrame === roundedValue) return prevFrame;
            return pids.map((p, cnfIndex) => {
                const overviewPid = allConfig?.[0]?.[pids[0]]?.ANGLES;
                return cnfIndex === 0
                  ? { [p]: roundedValue }
                  : { [p]: overviewPid?.[toIndex]?.[p]?.[p] };

            });
          });
            //  setFrame(+v.toFixed(0))
        }
      },
      onComplete: () => {
        setState(0);
        setRotate_Done(true);
      },
    });
   }else {
    animate(from, to, {
      duration: 0.2,
      ease: "linear",
      onUpdate: v => setFrame(+v.toFixed(0)),
       onComplete: () => {
        setState(0);
        setRotate_Done(true);
      },
    });
  }

  // animate( from, to, {
  //     duration:pin === 0 ? 0.5 : 0.2,
  //     transition: { ease:'linear' },
  //     onUpdate:(v) => setFrame(+v.toFixed(0)),
  //      onComplete: () => {
  //       setState(0);
  //       setRotate_Done(true);
  //     },
  //   })
  
  };
  
  

  const animation = {
    initial   : { opacity:0 },
    animate   : { opacity:1 },
    exit      : { opacity:0 },
    transition: { duration:0.5, ease:'linear' },
  }
const props = { type, isIsometry, pin, isMobile}
  return (
    <Main as={motion.div} {...animation}>
        {!isMobile && <Tooltip  showTooltip={showTooltip}/>}
      <ArrowButton variant={"primary"} {...props} clr={clr} onClick={() => click(-1)} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
        <Arrow {...props} D={'L'} w={ isMobile ? '20' : '20' } fill={pin===0 && type==="poly" && isIsometry ? isMobile ? clr.primary : "#FFF"  : clr?.primary }  {...{percent}}/>
      </ArrowButton>
      {/* { percent == 100 && <Label>{buttonsLabel?.filter( btn => btn.UILabelProperty === 'SkiftVinkel')[0]?.Label}</Label>} */}
      <ArrowButton variant={"primary"} {...props} clr={clr} isMobile={isMobile} onClick={() => click(+1)} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
        <Arrow {...props} D={'R'} w={ isMobile ? '20' : '20' } fill={pin===0 && type==="poly" && isIsometry ? isMobile ? clr.primary : "#FFF" : clr?.primary }  {...{percent}}/>
      </ArrowButton>
    </Main>
  )
}


export const Section = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 2px solid ${({ clr, pin, isMobile, isIsometry, type }) => pin===0 && type==="poly" && isIsometry ? isMobile ? `${clr?.primary}` : `#fff` : `${clr?.primary}` };;
  background: ${({ clr, pin, isMobile, isIsometry, type }) =>pin===0 && type==="poly" && isIsometry ? isMobile ? `${clr?.primary}bf` : `#ffffffbf` : `${clr?.primary_text}bf`};
  justify-content: center;
  align-items: center;
  gap: 10px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
`
export const ArrowButton = styled.button`

display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
 gap: 10px;
width: 40px;
height: 40px;
border-radius: 16px;
line-height: 1;
user-select: none;
border: ${({ clr, variant }) =>
  variant === "primary" ? "none" : "1px solid #D1D1D1"};

transition: background-color 0.1s ease-in, border 0.1s ease-in, box-shadow 0.1s ease-in;

${BREAK_.md_up} {
  height: 40px;
  // width: ${({ width }) => (width ? width : '205px')};
}

/* Background color logic */
background-color: ${({ variant, clr, pin, type, isIsometry, isMobile }) => {
  if (type === "poly" && pin === 0 && isIsometry) {
    return isMobile && variant === "primary"
      ? `${clr?.primary_text}`
      : clr?.primary_text;
  }
  if (type === "mono" && pin === 0 && isIsometry) {
    return isMobile && variant === "secondary"
      ? `${clr?.primary_text}`
      : `${clr?.primary_text}`;
  }
  return variant === "primary" ?  `${clr?.primary_text}`: clr?.buttons_text;
}};

&:hover {
  background-color: ${({ variant, clr, pin, type, isIsometry, isMobile }) => {
    if (type === "poly" && pin === 0 && isIsometry) {
      return isMobile && variant === "primary"
        ? darken(0.04, clr?.primary_text)
        : darken(0.04, clr?.primary_text)
    }
    if (type === "mono" && pin === 0 && isIsometry) {
      return isMobile && variant === "secondary"
        ? `#ffffffbf`
        : darken(0.04, clr?.primary_text);
    }
    return variant === "primary" ? darken(0.04, clr?.primary_text) : "#ffffffbf";
  }};
  
  border: ${({ clr, variant }) =>
    variant === "primary" ? "none" : "1px solid #D1D1D1"};
}


`;
// &:focus {
  
//   background-color: ${({ variant, clr, pin, type, isIsometry, isMobile }) => {
//      if (type === "poly" && pin === 0 && isIsometry) {
//        return isMobile && variant === "primary"
//          ? `${clr?.primary}bf`
//          : `#ffffffbf`;
//      }
//      if (type === "mono" && pin === 0 && isIsometry) {
//        return isMobile && variant === "secondary"
//          ? `#ffffffbf`
//          : `${clr?.primary}bf`;
//      }
//      return variant === "primary" ? `${clr?.primary}bf` : "#ffffffbf";
//    }};
   
//    /* box-shadow for primary and secondary variants */
//    box-shadow: ${({ variant, clr, isStatus }) => {
//      if (variant === "primary" && !isStatus) {
//        return `0 0 0 2.5px ${clr?.primary}`;  
//      }
//      if (variant === "secondary" && !isStatus) {
//        return `0 0 0 1.5px #D1D1D1`;  
//      }
//      return "none";
//    }};
//  }


